import { useState, useCallback } from 'react';
import * as transportOrderManagementAction from "../../../redux/store-sarang/transport-order/transport-order-management.store";
import * as cuisineOrderManagementAction from "../../../redux/store-sarang/cuisine-order/cuisine-order-management.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";

export const useShipperActions = ({
    showLoading,
    GetSumaryDelivery,
    searchData,
    buttonOpenConfirmRef,
    setCuisineData
}) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [isOpenActiveDialog, setOpenActiveDialog] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClosePopover = () => {
        setCuisineData([]);
        setAnchorEl(null);
    };

    const getListCuisineOrderManagement = async (queryData) => {
        try {
            const res = await cuisineOrderManagementAction.GetListCuisineOrderByShipper(
                1, 50, "orderDate desc" + (new Date().getHours() <= 13 ? ', receiptTime asc' : ', receiptTime desc'), queryData
            );
            if (res && res.content) {
                setCuisineData(res.content);
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        }
    };

    const handleDetailClick = (event, item) => {
        if (item.type === "CUISINE") {
            getListCuisineOrderManagement({ orderFromDate: item.deliveryDate, herdsmanId: item.herdsmanDeliveryId, receiptTime: item.receiptTime });
        } else {
            getListCuisineOrderManagement({ orderFromDate: item.deliveryDate, deliveryHerdsmanId: item.herdsmanDeliveryId, receiptTime: item.receiptTime });
        }
        setAnchorEl(event.currentTarget);
    };

    const openConfirmDialog = (item) => {
        setSelectedItem(item);
        buttonOpenConfirmRef.current.click();
    };

    const closeConfirmDialog = () => {
        setOpenActiveDialog(false);
        setSelectedItem(null);
    };

    const handleConfirm = async () => {
        showLoading(true);
        try {
            if (isOpenActiveDialog) {
                const res = await transportOrderManagementAction.SetHadSendToShipper({
                    deliveryDate: selectedItem.deliveryDate,
                    receiptTime: selectedItem.receiptTime,
                    herdsmanDeliveryId: selectedItem.herdsmanDeliveryId,
                    type: selectedItem.type,
                });
                if (res) {
                    GetSumaryDelivery(searchData);
                }
            }
            closeConfirmDialog();
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(viVN.Errors[err.errorType], NotificationMessageType.Error);
            }
        } finally {
            showLoading(false);
        }
    };

    return {
        selectedItem, setSelectedItem,
        isOpenActiveDialog, setOpenActiveDialog,
        anchorEl, setAnchorEl, open,
        handleClosePopover,
        handleDetailClick,
        openConfirmDialog,
        closeConfirmDialog,
        handleConfirm
    };
};
